import { Component, OnInit } from '@angular/core';
import { AppService } from 'app/app.service';

@Component({
	selector: 'app-core-cookie-consent',
	templateUrl: './core-cookie-consent.component.html'
})
export class CoreCookieConsentComponent implements OnInit {

	hidden = true;

	constructor(
		public app: AppService
	) { }

	ngOnInit() {
		this.hidden = this.app.getLocalFlag('cookieConsent');
	}

	accept() {
		this.hidden = true;
		this.app.setLocalFlag('cookieConsent', true);
	}

}
